import React from 'react';
import {Store} from '../../models/store.model';
import {MapPin, Edit, Trash2, Building} from 'lucide-react';

interface StoreDetailsHeaderProps {
  store: Store;
  onEdit?: (store: Store) => void;
  onDelete?: (storeId: string) => void;
}

export const StoreDetailsHeader: React.FC<StoreDetailsHeaderProps> = ({
  store,
  onEdit,
  onDelete
}) => {
  const handleEdit = () => {
    if (onEdit) {
      onEdit(store);
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      if (window.confirm('هل أنت متأكد من حذف هذا المتجر؟')) {
        onDelete(store.id.toString());
      }
    }
  };

  return (
    <div className="flex items-start justify-between">
      <div className="flex items-start gap-4">
        {store.profileImageUrl ? (
          <img
            src={store.profileImageUrl}
            alt={store.name}
            className="w-20 h-20 rounded-lg object-cover border-2 border-gray-100"
          />
        ) : (
          <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg flex items-center justify-center border-2 border-gray-100">
            <Building className="w-10 h-10 text-brand-600" />
          </div>
        )}
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-2">{store.name}</h3>
          <p className="text-gray-600 flex items-center gap-2">
            <MapPin className="w-4 h-4" />
            {store.address}
          </p>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-2">
        {onEdit && (
          <button
            onClick={handleEdit}
            className="flex items-center gap-2 px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition-colors"
          >
            <Edit className="w-4 h-4" />
            تعديل
          </button>
        )}
        {onDelete && (
          <button
            onClick={handleDelete}
            className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            <Trash2 className="w-4 h-4" />
            حذف
          </button>
        )}
      </div>
    </div>
  );
};


